// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2327": "bb4c22d1","2530": "e96a97f9","3923": "33323d61","4259": "04416507","5981": "9200fc8d",}[chunkId] + ".css"
}